import { Divider, Grid, Typography } from "@mui/material";
import InputField from "../../../utils/FormFields/InputField";
import SelectField from "../../../utils/FormFields/SelectField";
import {AddBranchRequestTimezoneEnum} from "../../../api/clinic-management/models/add-branch-request";
import keyLabel from "../../../utils/keylabel";
import CountryField from "../../../utils/FormFields/CountryField";

const timezoneTypes = keyLabel(AddBranchRequestTimezoneEnum);
const BranchAddress = () => {
  return (
    <>
      <Typography variant="h5" gutterBottom sx={{ p: 1 }}>
        Branch Address
      </Typography>
      <Divider />

      <Grid container rowSpacing={4} spacing={2} sx={{ pt: 8, justifyContent: "center", alignContent: "center" }}>
        <Grid item sm={12} md={6}>
          <InputField name="Name" label="Name" fullWidth />
        </Grid>
        <Grid container />
        <Grid item sm={12} md={6}>
          <InputField name="Address.Street" label="Street" fullWidth />
        </Grid>
        <Grid container />
        <Grid item sm={12} md={6}>
          <InputField name="Address.City" label="City" fullWidth />
        </Grid>
        <Grid container />
        <Grid item sm={12} md={3}>
          <CountryField name="Address.CountryCode" label="Country Code"/>
        </Grid>
        <Grid item sm={12} md={3}>
          <InputField name="Address.Zip" label="Zip" fullWidth />
        </Grid>
        <Grid container />
          <Grid item sm={12} md={6}>
            <SelectField
              name="Timezone"
              label="Timezone"
              data={timezoneTypes}
              type={AddBranchRequestTimezoneEnum}
              fullWidth
            />
          </Grid>
        <Grid container />
        <Grid item sm={12} md={6}>
          <InputField name="Address.Additional" label="Additional" fullWidth />
        </Grid>
        {/*<Grid container />*/}
        {/*<Grid item xs={12} sm={6}>*/}
        {/*  <BranchMap />*/}
        {/*</Grid>*/}
      </Grid>
    </>
  );
};

export default BranchAddress;
